export const activeClass = 'active'
export const allResponses = 'all'
export const added = 'added'
export const notAdded = 'notAdded'
export const reviewed = 'reviewed'
export const missed = 'missed'
export const payment = 'payment'
export const payout = 'payout'
export const cancelled = 'cancelled'
export const notFit = 'not-fit'
export const notLike = 'not-like'
export const endedStatus = 'ended'
export const submitted = 'submitted'
export const confirmed = 'confirmed'
export const thankValue = 'thank'
export const offensiveValue = 'offensive'
export const poorValue = 'poor'
export const gaReferrerBlacklist = ['google', 'soundcamps', 'spotify']
export const exceptStatus = ''
export const accepted = 'accepted'
export const awaiting = 'awaiting_review'
export const completed = 'completed'
export const rejected = 'canceled_by_artist'
export const awaiting_moderator_review = 'awaiting_moderator_review'
export const declined = 'declined'
export const activeTabStorage = 'active_tab'
